import Axios from './Base'

const PREFIX = '/_api_'
const ONE_MIN_IN_MS = 1000 * 60

export default class WalletLegacy {
  constructor(token) {
    this.token = `Bearer ${token.token}`
    this.wedId = token.token_payload.wed_id

    this.axios = Axios({
      cache: false,
      authorization: this.token,
      wedId: this.wedId,
    })
  }

  getWalletDetails() {
    const axiosWithCache = Axios({
      cache: true,
      authorization: this.token,
      wedId: this.wedId,
    })

    return axiosWithCache
      .get(`${PREFIX}/getWalletDetails?wed=${this.wedId}`, {
        id: 'wallet-details',
        cache: {
          ttl: ONE_MIN_IN_MS,
        },
      })
      .then((response) => response.data)
      .catch(() => false)
  }
}
